<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import SkillsCard from '@components/version-1/skills-card'
import UploadFile from '@components/upload-file'
import Multiselect from 'vue-multiselect'
import draggable from 'vuedraggable'
import SkillsTable from '@components/skills-table'
import requestFunctions from "@src/functions/requestFunctions"

export default {

	page: {
		title: 'Новый бот',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader, Multiselect, SkillsCard, UploadFile, SkillsTable, draggable },

	data() {
		return {
			title: 'Новый бот',
			items: [],
            trackBy: 'id',
            bot_uuid: '',
            name: '',
            description: '',

            audio_record: false,
            audio_record_variable: 'all_audio_record',

            background_sound: false,
            attachments: new Map(),

            trunk: null,
            initTrunk: [],
            trunks_options: [],

            inputs: [],

            options: {
                handle: '.handle',
                filter: '.disabled'
            },

            cnt_blocks: 0,
            blocks: [],

            saveModal: false,
            loadModal: false,
            callModal: false,

            call: {
                first_name: '',
                middle_name: '',
                last_name: '',
                variables: '',
                phone: '',
                attempts: 1,
                time_retries: null,
                delayed: false,
                delayed_at: null,
            },

            skill_name: null,
            skill_description: null,
            success_save_modal_text: null,
            success_save_modal: false
		}
	},

    watch: {

    },

	computed: {
        skill_item(){
            return this.$store.getters['skills/GET_SKILLS_ITEM'];
        },        
	    attachments_files: {
            get: function () {
                return this.attachments
            },
            set: function (value) {
                this.attachments = value;
            }
        },
        bot_item(){
            return this.$store.getters['bots/GET_BOTS_ITEM'];
        },
        trunks_list_data(){
            return this.$store.getters['trunks/GET_TRUNKS_LIST_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
	},

	async created() {

        this.bot_uuid = this.$route.params.bot_uuid ? this.$route.params.bot_uuid : '';

        await this.$store.dispatch('trunks/FETCH_TRUNKS_LIST', {});
        this.trunks_options = this.trunks_list_data;

        if(this.bot_uuid !== ''){

            this.title = 'Редактирование бота';
            document.title = appConfig.title + ' - ' + 'Редактирование бота';

            let data_send = {
                'uuid' : this.bot_uuid
            }

            await this.$store.dispatch('bots/FETCH_BOTS_ITEM', data_send);

            this.name        = this.bot_item.name         ? this.bot_item.name : '';
            this.description = this.bot_item.description  ? this.bot_item.description : '';
            this.config      = this.bot_item.config       ? JSON.parse(this.bot_item.config) : this.config;
            this.blocks      = this.bot_item.mind_map     ? JSON.parse(this.bot_item.mind_map) : this.blocks;
            this.cnt_blocks  = this.bot_item.mind_map_cnt ? this.bot_item.mind_map_cnt : '';

            if(this.config !== null){

                this.audio_record = this.config.audio_record;
                this.audio_record_variable = this.config.audio_record_variable;
                this.background_sound = this.config.background_sound;

                let attachments = new Map();

                if(this.config.background_sound_file && Object.keys(this.config.background_sound_file).length > 0) {

                    attachments.set(this.config.background_sound_file.uuid, {
                        'title'    : this.config.background_sound_file.title,
                        'filename' : this.config.background_sound_file.filename,
                        'status'   : this.config.background_sound_file.status,
                        'path'     : this.config.background_sound_file.path,
                        'ext'      : this.config.background_sound_file.ext,
                        'uuid'     : this.config.background_sound_file.uuid
                    })
                    this.attachments_files = attachments;
                }
            }

        } else {
            //this.addBlock();
            await this.saveItem(false);
        }
	},

	methods: {

        addBlock() {
            this.cnt_blocks = this.cnt_blocks + 1;
            this.blocks.push({
                id: this.cnt_blocks,
                parents_id: [],
                actions_code: [],
                action: null,
                description: null,
                sms_send: {},
                audio: {},
                record: {},
                stt_params: {},
                tts_params: {},
                text: null,
                intent: {},
                condition: {},
                http_request_params: {},
                next_action: null,
                set_variables: null
            })
        },

        deleteBlock(index) {
            this.blocks.splice(index, 1);
            return false;
        },

        async loadSkill(uuid) {

            let data_send = {
                'uuid' : uuid
            }

            await this.$store.dispatch('skills/FETCH_SKILLS_ITEM', data_send);

            let blocks = this.skill_item.mind_map ? JSON.parse(this.skill_item.mind_map) : null;

            // Копируем файлы в bots

            for (const el of blocks) {
                if(el.audio.filename && el.audio.filename !== null){
                    // копируем физически
                    data_send = {
                        attaching_type_to   : 'bots',
                        attaching_type_from : 'skills',
                        path_to   : this.bot_uuid,
                        path_from : el.audio.path,
                        filename  : el.audio.filename,
                        action    : 'copy'
                    }

                    let query_url = 'https://api.client.za-bota.com/uploads/';
                    let response = await requestFunctions.sendDataAsync(query_url, data_send, 'POST');

                    // создаем в базе с новым path
                    data_send = {
                        title    : el.audio.title,
                        path     : this.bot_uuid,
                        status   : 'success',
                        filename : el.audio.filename,
                        ext      : el.audio.ext,
                        attaching_uuid : this.bot_uuid,
                        attaching_type : 'bots'
                    }

                    let new_file = await this.$store.dispatch('files/FETCH_FILES_CREATE', data_send);

                    // обновляем значения path и uuid в data
                    el.audio.path = this.bot_uuid;
                    el.audio.uuid = new_file.uuid;
                }
            }

            this.blocks     = blocks;
            this.cnt_blocks = this.skill_item.mind_map_cnt ? this.skill_item.mind_map_cnt : '';

            this.loadModal = false;

            return false;
        },

        async saveBlocks() {

            let data_send = {
                'name' : this.skill_name,
                'description' : this.skill_description,
            };

            let new_skill = '';
            new_skill = await this.$store.dispatch('skills/FETCH_SKILLS_CREATE', data_send);

            let mind_map = [];

            let cnt = 0;
            for (const el of this.blocks) {
                let block_data = this.$refs['block_' + el.id][0];
                let data = block_data.getData();

                // Копируем файлы в skills

                if(data.audio.filename && data.audio.filename !== null){
                    // копируем физически
                    data_send = {
                        attaching_type_to   : 'skills',
                        attaching_type_from : 'bots',
                        path_to   : new_skill.uuid,
                        path_from : this.bot_uuid,
                        filename  : data.audio.filename,
                        action    : 'copy'
                    }

                    let query_url = 'https://api.client.za-bota.com/uploads/';
                    let response = await requestFunctions.sendDataAsync(query_url, data_send, 'POST');

                    // создаем в базе с новым path
                    let data_send = {
                        title    : data.audio.title,
                        path     : new_skill.uuid,
                        status   : 'success',
                        ext      : data.audio.ext,
                        filename : data.audio.filename,
                        attaching_uuid : new_skill.uuid,
                        attaching_type : 'skills'
                    }

                    let new_file = this.$store.dispatch('files/FETCH_FILES_CREATE', data_send);

                    // обновляем значения path и uuid в data
                    data.audio.path = new_skill.uuid;
                    data.audio.uuid = new_file.uuid;
                }

                mind_map.push(data);
            };

            data_send = {
                'uuid' : new_skill.uuid,
                'mind_map' : JSON.stringify(mind_map),
                'mind_map_cnt' : this.cnt_blocks,
            };

            let result = await this.$store.dispatch('skills/FETCH_SKILLS_UPDATE', data_send);

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.saveModal = false;
                this.success_save_modal = true;
            }
        },

        async saveItem(redirect = true){

            let mind_map = [];

            this.blocks.forEach(el => {
                let block_data = this.$refs['block_' + el.id][0];
                let data = block_data.getData();
                mind_map.push(data);
            });

            this.config = {
                'audio_record' : this.audio_record,
                'audio_record_variable' : this.audio_record_variable,
                'background_sound': this.background_sound,
                'background_sound_file': {}
            }

            if(this.attachments.size > 0){
                let attachments = [];
                this.attachments.forEach(el => {
                    attachments.push(el);
                })
                this.config['background_sound_file'] = attachments[0];
            }

            let data_send = {
                'name' : this.name,
                'description' : this.description,
                'config'   : JSON.stringify(this.config),
                'mind_map' : JSON.stringify(mind_map),
                'mind_map_cnt' : this.cnt_blocks,
                'version': 1,
            };

            let result = '';

            if(this.bot_uuid === ''){
                result = await this.$store.dispatch('bots/FETCH_BOTS_CREATE', data_send);
                this.bot_uuid = result.uuid;
            } else {
                data_send.uuid = this.bot_uuid;
                result = await this.$store.dispatch('bots/FETCH_BOTS_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                if (redirect === false) {
                    return false;
                } else {
                    this.$router.push({name: 'Bots'});
                }
            }
        },

        async sendCall(){
            await this.saveItem(false);

            let variables = {};

            if(this.call.variables !== ''){
                variables = JSON.parse(this.call.variables);
            }
            variables.first_name  = this.call.first_name;
            variables.middle_name = this.call.middle_name;
            variables.last_name   = this.call.last_name;
            variables.phone       = this.call.phone;

            let data_send = {
                'contact_phone' : this.call.phone,
                'variables'     : JSON.stringify(variables),
                'bot_uuid'      : this.bot_uuid,
                'trunk_id'      : this.trunk && this.trunk.id ? this.trunk.id : '',
                'attempts'      : this.call.attempts,
                'time_retries'  : this.call.time_retries,
                'delayed_at'    : this.call.delayed_at,
                'status'        : this.call.delayed === false || this.call.delayed === '' ? 'created' : 'delayed'
            };
            await this.$store.dispatch('calls/FETCH_CALLS_CREATE', data_send);
            this.callModal = false;
        }
	}
}

</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />

        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">

                                    <b-form-group
                                        label="Имя бота"
                                        label-for="name"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="name"
                                            placeholder="Укажите имя бота"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Описание"
                                        label-for="description"
                                    >
                                        <b-form-input
                                            id="description"
                                            v-model="description"
                                            placeholder="Укажите краткое описание бота"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-checkbox v-model="audio_record" name="config_record" style="margin-top: 5px; margin-bottom: 5px" switch>
                                        Включить запись разговора
                                    </b-form-checkbox>

                                    <b-form-checkbox v-model="background_sound" name="config_background_sound" style="margin-top: 5px; margin-bottom: 5px" switch>
                                        Включить фоновый звук
                                    </b-form-checkbox>

                                    <UploadFile
                                        v-bind:attaching_uuid="bot_uuid"
                                        v-bind:attaching_type="'bots'"
                                        v-bind:attachments="attachments_files"
                                        v-bind:btn_title="'Загрузить фоновый звук'"
                                        v-bind:multiple="true"
                                        v-bind:btn_icn="'uil-music'"
                                        v-show="background_sound"
                                    />

                                    <div class="row" style="margin-top: 50px !important; margin-bottom: 30px !important;">
                                        <div class="col-sm-12 col-xl-4">
                                            <h4 class="mb-3 mt-0 header-title" style="margin-top: 20px !important; margin-bottom: 0px !important;"><i class="feather uil uil-sitemap"></i>Сценарий</h4>
                                        </div>
                                        <div class="col-sm-12 col-xl-8">
                                            <a href="#" @click.prevent="saveModal = true" class="btn btn-outline-secondary btn float-sm-right" style="margin-left: 7px; margin-top: 10px">
                                                <i class="uil uil-file-check-alt "></i>Сохранить сценарий
                                            </a>
                                            <a href="#" @click.prevent="loadModal = true" class="btn btn-outline-secondary btn float-sm-right" style="margin-top: 10px; margin-left: 7px; margin-right: 7px">
                                                <i class="uil uil-file-download-alt "></i>Загрузить сценарий
                                            </a>
                                        </div>
                                    </div>

                                    <div v-show="blocks.length > 0" class="row" style="margin-bottom: 30px">
                                        <div class="col-12" id="mind-map">
                                            <draggable v-model="blocks" class="list-group draggable">
                                                <transition-group>
                                                    <SkillsCard v-for="(block, index) in blocks"  v-bind:skill_uuid="null" v-bind:bot_uuid="bot_uuid" v-bind:index="index" :ref="'block_' + block.id" v-bind:params="block" :key="block.id"/>
                                                </transition-group>
                                            </draggable>
                                        </div>
                                    </div>

                                    <div class="row" style="max-width: 925px; padding-top: 0px; padding-bottom: 0px; justify-content: center;">
                                        <div class="col">
                                            <a href="#" @click.prevent="addBlock()" class="btn btn-light btn-block add-block" style="border: 1px dashed #d4d4d4; padding-top:45px; padding-bottom:45px;">
                                                <i class="uil uil-plus-circle "></i>Добавить блок
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <hr style="margin-bottom: 0px !important">
                        <div style="padding: 0.75rem">
                            <button type="submit" class="btn btn-primary btn" style="margin-right: 10px">Сохранить</button>
                            <button type="button" @click="callModal = true" class="btn btn-outline-primary btn"><i class="uil uil-play "></i> Протестировать</button>
                        </div>
                        <!-- end card-body -->
                    </div>
                    <!-- end card-->
                </div>
                <!-- end col -->
            </div>
        </b-form>

        <b-modal
            v-model="saveModal"
            centered
            size="lg"
            title="Новый сценарий"
            title-class="font-18"
        >
            <b-form-group
                label="Название сценария"
                label-for="skill_name"
            >
                <b-form-input
                    id="skill_name"
                    v-model="skill_name"
                    placeholder="Укажите название нового сценария"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                label="Комментарий к сценарию"
                label-for="skill_description"
            >
                <b-form-input
                    id="skill_description"
                    v-model="skill_description"
                    placeholder=""
                ></b-form-input>
            </b-form-group>

            <template v-slot:modal-footer style="justify-content: flex-start !important">
                <div style="width: 100%">
                    <b-button variant="primary" class="btn" @click="saveBlocks" style="margin-right: 10px">Сохранить</b-button>
                    <b-button variant="light" class="btn" @click="saveModal = false"
                    >Отменить</b-button
                    >
                </div>
            </template>
        </b-modal>

        <b-modal
            v-model="loadModal"
            scrollable
            size="lg"
            title="Сценарии"
            title-class="font-18"
            hide-footer
        >
            <SkillsTable v-bind:is_popup="true" />
        </b-modal>

        <b-modal
            v-model="success_save_modal"
            centered
            hide-footer
            title="Успешно"
            title-class="font-18"
        >
            <div class="text-center">
                <i class="uil-sitemap text-success display-3" style="margin-bottom: 15px"></i>
                <h4 class="mt-4" style="margin-bottom: 15px">Сценарий успешно сохранен</h4>
                <p class="w-75 mx-auto text-muted">{{success_save_modal_text}}</p>
                <div class="mt-4">
                    <button
                        class="btn btn-outline-primary btn width-md"
                        style="margin-top: 15px"
                        @click="success_save_modal = false"
                    >
                        <i class="uil uil-arrow-left "></i> Вернуться
                    </button>
                </div>
            </div>
        </b-modal>

        <b-modal
            v-model="callModal"
            centered
            size="lg"
            title="Тестирование бота"
            title-class="font-18"
        >

            <b-form-group
                label="Транк"
                label-for="trunk"
            >
                <multiselect
                    id="trunk"
                    :track-by="trackBy"
                    v-model="trunk"
                    :options="trunks_options"
                    placeholder="Выберите из списка"
                    selectLabel="Нажмите, чтобы выбрать"
                    deselectLabel="Нажмите, снять выделение"
                    label="name"
                ></multiselect>
            </b-form-group>

            <b-form-group
                label="Номер телефона"
                label-for="call_phone"
            >
                <b-form-input
                    id="call_phone"
                    v-model="call.phone"
                    placeholder="Укажите номер телефона"
                ></b-form-input>
            </b-form-group>
            <br>
            <b-form-group
                label="Имя"
                label-for="call_first_name"
            >
                <b-form-input
                    id="call_first_name"
                    v-model="call.first_name"
                    placeholder="Укажите имя"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                label="Отчество"
                label-for="call_middle_name"
            >
                <b-form-input
                    id="call_middle_name"
                    v-model="call.middle_name"
                    placeholder="Укажите отчество"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                label="Фамилия"
                label-for="call_last_name"
            >
                <b-form-input
                    id="call_last_name"
                    v-model="call.last_name"
                    placeholder="Укажите фамилию"
                ></b-form-input>
            </b-form-group>
            <br>
            <b-form-group
                label="JSON параметры"
                label-for="call_variables"
            >
                <b-form-textarea
                    id="call_variables"
                    v-model="call.variables"
                    placeholder='{"var1" : "значение"};'
                    rows="4"
                ></b-form-textarea>
            </b-form-group>
            
            <div class="row">
                <div class="col-sm-12 col-xl-6">
                    <b-form-group
                        label="Попыток дозвона"
                        label-for="attempts"
                    >
                        <b-form-input
                            id="attempts"
                            v-model="call.attempts"
                            placeholder="1"
                        ></b-form-input>
                    </b-form-group>
                </div>

                <div class="col-sm-12 col-xl-6">
                    <b-form-group
                        label="Время повторных звонков"
                        label-for="time_retries"
                    >
                        <b-form-input
                            id="time_retries"
                            v-model="call.time_retries"
                            placeholder="1d 1h 10m"
                        ></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <b-form-checkbox v-model="call.delayed" name="config_record" style="margin-top: 5px; margin-bottom: 15px" switch>
                Отложенный звонок
            </b-form-checkbox>

            <b-form-group
                v-if="call.delayed"
                label="Дата и время звонка"
                label-for="delayed_at"
            >
                <b-form-input
                    id="delayed_at"
                    v-model="call.delayed_at"
                    placeholder="00:00:00 01.01.2022"
                ></b-form-input>
            </b-form-group>

            <template v-slot:modal-footer style="justify-content: flex-start !important">
                <div style="width: 100%">
                    <b-button variant="primary" class="btn" @click="sendCall" style="margin-right: 10px">Сохранить</b-button>
                    <b-button 
                        variant="light" 
                        class="btn" 
                        @click="callModal = false"
                    >Отменить</b-button>
                </div>
            </template>

        </b-modal>

	</Layout>
</template>

<style>
    .add-block {
        background-color: #ffffff;
        transition: all .5s;
    }

    .add-block:hover {
        background-color: #f8f9fa;
    }

    .add-block:focus {
        background-color: #ffffff;
    }

    .list-group-item.draggable {
        transition: all .2s;
    }
    .list-group.draggable {
        transition: all .2s;
    }
</style>
